export default {
  props: {
    message: {
      type: Object,
      default: null
    }
  }
};
